import React from 'react'
import { Grid, Table, TableHead, TableBody, TableRow, TableCell, Paper, LinearProgress } from '@material-ui/core'

import { BlacklistBooking } from './components/BlackistBooking'

export const BlacklistBookingsBase = (props) => {
  const { classes, blacklistPageBookings, isLoading } = props

  return (
    <Grid
      container
      wrap='nowrap'
      spacing={32}
      className={classes.container}
      component={Paper}
    >
      <Grid xs item>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell padding='dense' />

              <TableCell padding='dense'>
                №
              </TableCell>

              <TableCell padding='dense'>
                Звідки
              </TableCell>

              <TableCell padding='dense'>
                Куди
              </TableCell>

              <TableCell padding='dense'>
                Прізвище
              </TableCell>

              <TableCell padding='dense'>
                Імя
              </TableCell>

              <TableCell padding='dense'>
                Телефон
              </TableCell>

              <TableCell padding='dense'>
                Ціна
              </TableCell>

              <TableCell padding='dense'>
                Відмітка
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading && (
              <TableRow>
                <TableCell colSpan='9'>
                  <LinearProgress />
                </TableCell>
              </TableRow>
            )}
            {!isLoading && blacklistPageBookings.map((booking, index) => (
              <BlacklistBooking key={booking.id} {...booking} index={index} />
            ))}
          </TableBody>
        </Table>
      </Grid>
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./src/components/BlacklistBookings/BlacklistBookings.js